<script>
    import Badge from "./base/Badge.svelte";
    import Button from "./base/Button.svelte";

    export var tags = [];
    export var title = "Default title";
    export var text = "Default text";
    export var link;
    export var company = "";
    export var image = "";
</script>

<div class="flex flex-col bg-secondary text-primary rounded-lg p-8 h-full">
    <div class="flex flex-col lg:flex-row space-y-8 lg:space-y-0 lg:space-x-8 items-center">
        {#if !!image}
            <div class="-mt-20 lg:-mt-14 drop-shadow-lg shrink-0 lg:self-start">
                <img
                    class="bg-basic rounded-lg p-2 h-32 w-32 lg:h-28 lg:w-28"
                    src={image}
                    alt={company}
                />
            </div>
        {/if}
        <div class="w-full flex">
            <div class="grow">
                <p class="2xl:text-3xl text-2xl">{title}</p>
                <p class="text-lg font-extralight">{company}</p>
            </div>
            {#if !!link}
                <div class="self-start">
                    <Button
                        href={link}
                        target="_blank"
                        rel="noreferrer"
                        border={false}
                        ariaLabel="Voir le projet {title}"
                    >
                        <i class="fas fa-external-link-alt" />
                    </Button>
                </div>
            {/if}
        </div>
    </div>
    <div class="flex flex-col justify-between mt-4 self-end h-full max-w-full">
        <p>{text}</p>
        <div class="flex space-x-2 mt-4 max-w-full overflow-x-scroll">
            {#each tags as tag}
                <Badge color="primary">{tag.name}</Badge>
            {/each}
        </div>
    </div>
</div>
